/* unplugin-vue-components disabled */import { render } from "./MyLike.vue?vue&type=template&id=33e60e67&scoped=true"
import script from "./MyLike.vue?vue&type=script&lang=js"
export * from "./MyLike.vue?vue&type=script&lang=js"

import "./MyLike.vue?vue&type=style&index=0&id=33e60e67&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e60e67"]])

export default __exports__